export const APP_FONT_FAMILY = "'Bricolage Grotesque', system-ui, sans-serif";
